import {type ClassValue, clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

/**
 * cn — склейка className с разрешением конфликтов Tailwind-классов.
 * Стандартный хелпер shadcn/ui. Используется во всех ui-компонентах.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
